function getWithDefaultBase(map, key, getDefault) {
    if (map.has(key)) {
        return map.get(key);
    }
    const defaultValue = getDefault();
    map.set(key, defaultValue);
    return defaultValue;
}
export default function getWithDefault(...args) {
    return this
        ? getWithDefaultBase(this, ...args)
        : getWithDefaultBase(...args);
}
//# sourceMappingURL=main.js.map